import React from 'react';

import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function Component(props) {
	return (
		<FormControl variant={props.variant} fullWidth>
			<InputLabel>{props.label}</InputLabel>
			<Select
				value={props.value}
				onChange={props.onChange}
				disabled={props.disabled}
				label={props.label}
				renderValue={props.renderValue}
				MenuProps={{ disableScrollLock: true }}
			>
				{props.children}
			</Select>
			{props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
		</FormControl>
	);
}

Component.defaultProps = {
	variant: 'outlined',
	label: '',
	value: '',
	disabled: false,
	// Same slot a TextField's own helperText occupies, so a select's help
	// text is one mechanism with the rest of a form instead of a
	// separately-styled sibling Typography.
	helperText: null,
	// A menu option that renders more than its own name (see Captions.js's
	// provider picker) needs its own closed-field rendering, or the extra
	// lines end up inside the field.
	renderValue: undefined,
	onChange: function (event) {},
};
